module.exports = __webpack_public_path__ + "media/student_lending_center/simpletuition-logo-6261679f.png";